import { useEffect, useState } from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import axios from 'axios';
import { Loader2, ShieldAlert } from 'lucide-react';
import { Button } from '../components/ui/button';

const API_URL = process.env.REACT_APP_BACKEND_URL;

export default function TaskLoginPage() {
  const [params] = useSearchParams();
  const [error, setError] = useState('');

  useEffect(() => {
    const token = params.get('token');
    const next = params.get('next') || '/';
    if (!token) { setError('Missing link token'); return; }
    axios.post(`${API_URL}/api/auth/magic-login`, { token }, { withCredentials: true })
      .then(() => { window.location.replace(next); })
      .catch(err => setError(err.response?.data?.detail || 'This link is invalid or expired.'));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#F7F6F3] px-6" data-testid="task-login-page">
      {error ? (
        <div className="text-center space-y-3 max-w-sm">
          <ShieldAlert className="w-10 h-10 text-amber-500 mx-auto" />
          <p className="text-sm text-slate-700" data-testid="task-login-error">{error}</p>
          <Button asChild variant="outline" className="rounded-full">
            <Link to="/login">Log in with OTP instead</Link>
          </Button>
        </div>
      ) : (
        <div className="text-center space-y-3">
          <Loader2 className="w-8 h-8 animate-spin text-[#0E5132] mx-auto" />
          <p className="text-sm text-muted-foreground">Signing you in…</p>
        </div>
      )}
    </div>
  );
}
